module.exports = __webpack_public_path__ + "static/media/midkniteathletics.889224df.png";